import React from 'react';
import { XIcon } from 'lucide-react';
import { painPoints } from '../data/content';
export function PainSection() {
  return <section aria-labelledby="dolor-titulo" className="ruled-paper w-full border-y border-navy/10 bg-white py-14 sm:py-20" data-id="element-201" data-mp="38wlvkxicj0ju">
      <div className="mx-auto max-w-3xl px-5" data-id="element-202" data-mp="2v0i5ngei9ed6">
        <h2 id="dolor-titulo" className="font-display text-3xl font-extrabold leading-tight text-navy text-balance sm:text-4xl" data-id="element-203" data-mp="2yypgxvq79ngz">
          ¿Cuántos domingos más vas a perder así?
        </h2>

        <div className="mt-5 space-y-3 text-base leading-relaxed text-navy/80 sm:text-lg" data-id="element-204" data-mp="2q0dkve6kdxh5">
          <p data-id="element-205" data-mp="2bbr89k8bnjtm">
            Sos padre, madre o docente. Amás acompañar a los chicos. Pero nadie te dijo
            que ibas a pasar los domingos buscando actividades que no encajan, armando
            fichas a la noche y llegando al lunes con material que “más o menos sirve”.
          </p>
          <p className="font-bold text-navy" data-id="element-206" data-mp="2779q1phm1eky">
            No es falta de dedicación. Es falta de un sistema.
          </p>
        </div>

        <ul className="mt-8 space-y-3" data-id="element-207" data-mp="3rovhp6ypl0ey">
          {painPoints.map(point => <li key={point} className="flex items-start gap-3 rounded-xl border border-coral/15 bg-coral/5 px-4 py-3" data-id="element-208" data-mp="3nl5vup9f4wxm">
              <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-coral" aria-hidden="true" data-id="element-209" data-mp="gg464hqhsbq" />
              <span className="text-sm leading-relaxed text-navy/85 sm:text-base" data-id="element-210" data-mp="38wsu1bnngjv7">
                {point}
              </span>
            </li>)}
        </ul>

        <p className="mt-9 text-center font-display text-2xl font-extrabold text-celeste-dark sm:text-3xl" data-id="element-211" data-mp="3ine17nhe2wpq">
          ¿Y si este fuera el último domingo que pasás así?
        </p>
      </div>
    </section>;
}